import { SelectOptions } from "@usitsdasdesign/dds-ng/select";
export const selectOptions: SelectOptions = {
    placeholder: 'Select Reason'
}